// Zentrales MUI-Theme: Glas-Optik wie Header/Blog, Sitzblau als Primärfarbe,
// Notarzt-Rot nur für Fehler/Warnung und als schmale Oberkante der Dialoge.
import { createTheme } from '@mui/material/styles'
import '@fontsource/ibm-plex-sans/400.css'
import '@fontsource/ibm-plex-sans/500.css'
import '@fontsource/ibm-plex-sans/600.css'
import '@fontsource/ibm-plex-mono/400.css'
import '@fontsource/ibm-plex-mono/700.css'

const blau = '#1F3F8F'
const rot = '#C8102E'
const text = '#14171F'
const textSekundaer = '#5B6170'
const glas = 'rgba(255, 255, 255, 0.78)'
const glasKante = '1px solid rgba(255, 255, 255, 0.6)'
const glasFilter = 'blur(18px) saturate(1.2)'
const linie = 'rgba(20, 23, 31, 0.14)'

export const theme = createTheme({
    palette: {
        primary: { main: blau, dark: '#16306E', light: '#4C67B3' },
        error: { main: rot },
        text: { primary: text, secondary: textSekundaer },
        divider: linie,
    },
    shape: { borderRadius: 10 },
    typography: {
        fontFamily: '"IBM Plex Sans", system-ui, -apple-system, "Segoe UI", sans-serif',
        h6: { fontWeight: 600, letterSpacing: '-0.01em' },
        subtitle1: { fontWeight: 500 },
        button: { textTransform: 'none', fontWeight: 600, letterSpacing: 0 },
    },
    components: {
        MuiDialog: {
            styleOverrides: {
                paper: {
                    borderRadius: 16,
                    backgroundColor: glas,
                    backdropFilter: glasFilter,
                    border: glasKante,
                    borderTop: `4px solid ${rot}`,
                    boxShadow: '0 24px 60px rgba(20, 23, 31, 0.28)',
                    // Eingebettete Papers (Tabellen, Stepper-Seiten) nicht als weiße Blöcke im Glas
                    '& .MuiDialogContent-root .MuiPaper-root': {
                        backgroundColor: 'transparent',
                        backgroundImage: 'none',
                        boxShadow: 'none',
                    },
                    '@media (max-width: 600px)': {
                        margin: 8,
                        width: 'calc(100% - 16px)',
                        maxWidth: 'calc(100% - 16px)',
                        maxHeight: 'calc(100% - 16px)',
                    },
                },
            },
        },
        MuiBackdrop: {
            styleOverrides: {
                root: {
                    '&:not(.MuiBackdrop-invisible)': { backgroundColor: 'rgba(20, 23, 31, 0.38)' },
                },
            },
        },
        MuiDialogTitle: {
            styleOverrides: {
                root: { fontSize: '1.25rem', fontWeight: 600, letterSpacing: '-0.01em', padding: '20px 24px 8px' },
            },
        },
        MuiDialogContent: {
            styleOverrides: { root: { padding: '8px 24px 16px' } },
        },
        MuiDialogActions: {
            styleOverrides: { root: { padding: '8px 24px 20px', gap: 8 } },
        },
        MuiButton: {
            defaultProps: { disableElevation: true },
            styleOverrides: {
                root: { borderRadius: 10, paddingInline: 18 },
                sizeSmall: { paddingInline: 12 },
                outlined: { borderColor: linie, backgroundColor: 'rgba(255, 255, 255, 0.45)' },
            },
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    borderRadius: 10,
                    backgroundColor: 'rgba(255, 255, 255, 0.55)',
                    '& .MuiOutlinedInput-notchedOutline': { borderColor: linie },
                    '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(20, 23, 31, 0.35)' },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderWidth: 2 },
                },
            },
        },
        MuiFormHelperText: {
            styleOverrides: { root: { marginLeft: 4 } },
        },
        MuiMenu: {
            styleOverrides: {
                paper: {
                    borderRadius: 12,
                    backgroundColor: glas,
                    backdropFilter: glasFilter,
                    border: glasKante,
                    boxShadow: '0 12px 32px rgba(20, 23, 31, 0.22)',
                },
            },
        },
        MuiTab: {
            styleOverrides: { root: { textTransform: 'none', fontWeight: 600 } },
        },
        MuiTableCell: {
            styleOverrides: {
                root: { borderBottom: `1px solid rgba(20, 23, 31, 0.08)` },
                head: { fontWeight: 600, color: textSekundaer, borderBottom: `1px solid ${linie}` },
            },
        },
        MuiStepLabel: {
            styleOverrides: { label: { fontWeight: 500 } },
        },
    },
})
